/**
 * The keys that more than one tag uses, each listed once. S3 refuses to save two tags with the same
 * key ("Cannot provide multiple Tags with the same key"); keys are compared exactly, case included.
 */
export function duplicateTagKeys(tags: ReadonlyArray<{ key: string }> | null | undefined): string[] {
  const seen = new Set<string>();
  const duplicates = new Set<string>();
  for (const {key} of tags ?? []) {
    (seen.has(key) ? duplicates : seen).add(key);
  }
  return [...duplicates];
}
